// Constants and flag for the local mock flow (see docs/LOCAL_MOCK_FLOW.md).
//
// `__MOCK_BFF__` is injected by Vite `define` (vite.config.ts): `true` only when the
// dev server is started with MOCK_BFF set, `false` in normal dev and prod builds — so
// the mock-tap control never ships to QA/prod.

/** PUID advertised by the mock BFF session; equals MOCK_TAP_MESSAGE.slice(16, 32). */
export const MOCK_TAP_PUID = 'A1B2C3D4E5F60718';

/**
 * Canned 80-char "v2" AirKey card message fed to the real `onCardTapResult` handler
 * by the dev "Simulate tap" control. The templates derive the PUID as
 * `message.slice(16, 32)`, so it must equal MOCK_TAP_PUID (advertised by the mock
 * session) for the client PUID gate to pass. Bytes outside the PUID are ignored.
 */
export const MOCK_TAP_MESSAGE = `0202000000000000${MOCK_TAP_PUID}${'0'.repeat(48)}`;

/** True only in the local mock flow (MOCK_BFF dev server); false in prod. */
export function isMockFlowEnabled(): boolean {
  return typeof __MOCK_BFF__ !== 'undefined' && __MOCK_BFF__ === true;
}
